import React from 'react';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';

import { useAuthenticatedState } from 'src/authenticated-state/context';
import { Flex, FlexColumn } from 'src/components/flex';
import Responsive from 'src/components/responsive';
import ButtonLink from 'src/components/button-link';
import { isUnmatchedListingNotification } from 'src/services/api/notifications';
import pluralize from 'pluralize';

export default function UnmatchedListingAlert() {
    const { notifications } = useAuthenticatedState();
    const unmatchedListings = notifications
        .filter(isUnmatchedListingNotification)
        .filter((notification) => !notification.is_read_by_user);
    const numUnmatchedListings = unmatchedListings.length;
    if (numUnmatchedListings === 0) {
        return null;
    }

    return (
        <Responsive desktop>
            <Alert
                severity="error"
                color="error"
                sx={{
                    '& .MuiAlert-message': { width: '100%' },
                    '& .MuiAlert-icon': { paddingTop: '10px' },
                }}
            >
                <Flex width="100%" justifyContent="space-between" alignItems="center">
                    <FlexColumn>
                        <Typography fontWeight="bold" color="error">
                            Unmatched Listings
                        </Typography>
                        <Typography variant="body2" color="error">
                            {`${numUnmatchedListings} ${pluralize('listings', numUnmatchedListings)} ${numUnmatchedListings === 1 ? 'is' : 'are'} not matched to a property.`}
                        </Typography>
                    </FlexColumn>

                    <ButtonLink variant="outlined" color="error" href="/landlord/inner/properties/listings">
                        {`View ${pluralize('listing', numUnmatchedListings)}`}
                    </ButtonLink>
                </Flex>
            </Alert>
        </Responsive>
    );
}
